<template>
    <div class="technologypage" style="background: #fff">
        <el-card style="position: relative; padding-bottom: 10px">
            <el-row>
                <el-col :span="12">
                    <div style="font-size: 20px; font-weight: bold; color: #4b92ff">{{ tabInfo.name }}</div>
                    <div style="display: flex;align-items:baseline">
                        <span style="font-weight: 600;">{{ tabInfo.type }} <span v-show="tabInfo.description">•</span>
                        </span>
                        <span :title="tabInfo.description" class="tabInfo-des">{{ tabInfo.description }}
                        </span>
                    </div>
                </el-col>
                <el-col :span="8">
                    <span>{{ $t("message.title.rev") }}: </span>
                    <el-select v-model="change_value" size="mini"
                        style="width: 53%; overflow: hidden; position: relative; top: 10px" @change="changeInfoClick">
                        <el-option v-for="item in changeInfo" :key="item.value" :label="item.text" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-dropdown placement="bottom" style="margin-left: 10px" @visible-change="checkDelPriv">
                        <el-button size="small">
                            {{ $t("message.button.actions")
                            }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="creatChange = true" :style="{ display: visibleCreate }">{{
                                $t("message.button.createChange")
                                }}</el-dropdown-item>
                            <!-- <el-dropdown-item @click.native="saveAs = true">{{
                                $t("message.button.saveAs")
                            }}</el-dropdown-item> -->
                            <el-dropdown-item @click.native="addFavorite">{{
                                $t("message.button.bookmark")
                                }}</el-dropdown-item>
                            <el-dropdown-item @click.native="removeFavorite">{{
                                $t("message.button.cancelBookmark")
                                }}</el-dropdown-item>
                            <el-dropdown-item :disabled="!deletePriv" @click.native="deleteTechnology">{{
                                $t("message.button.delete")
                                }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
                <el-col :span="4" :offset="8" style="font-size: 28px;">
                    {{ tabInfo.lifeCycle }}
                </el-col>
            </el-row>
        </el-card>
        <el-dialog v-if="creatChange" class="searchAddChangeList" :title="$t('message.title.add')"
            :visible.sync="creatChange" :close-on-click-modal="!creatChange">
            <Create :baseClass="baseClass_" :creatBy='createTechnologyChange' @addToList="addToChangeList"
                @closeCreateNew="closeCreateChange"></Create>
        </el-dialog>
        <el-dialog v-if="saveAs" class="searchAddTechnologyList" :title="$t('message.title.saveAs')"
            :visible.sync="saveAs" :close-on-click-modal="!saveAs">
            <save-as-form :versionList="changeInfo" @close="cancelSaveAs"></save-as-form>
        </el-dialog>
        <!-- tab切换 -->
        <div class="content">
            <div class="content-title">
                <div @click="tabClick(item, index)" class="content-item" :class="{ active: index == num }"
                    v-for="(item, index) in tabList" :key="index">
                    <div style="display: flex;">
                        <div>
                            {{ item.name }}
                        </div>
                        <div :style="{ 'visibility': item.isResult ? 'visible' : 'hidden', }"
                            style=" margin-left: 3px;font-size: 22px;">*</div>
                    </div>
                </div>
            </div>
            <div style="height: 6px;background: #ebebeb;"></div>
            <!-- <router-view :relUrl="relUrl" v-if="isRouterAlive" :type="technology" @routeClick="reload"
                @setPageRefresh="pageRefresh" :currentStatusId="workflowInfo.currentStatusId" :changeRevInfo="changeInfo" /> -->
            <router-view :relUrl="relUrl" v-if="isRouterAlive" :type="technology" @routeClick="reload"
                @setPageRefresh="pageRefresh" @refreshTab="refreshTab" :currentStatusId="workflowInfo.currentStatusId"
                :changeRevInfo="changeInfo" />
        </div>
    </div>
</template>
<script>
import axios from "axios";
import Create from "@/components/common/Create.vue";
import SaveAsForm from "../common/saveAsFormForCommon.vue";
import { technologyTabList } from "@/utils/publicstate";
import { getTabIndex } from "@/utils/index.js"

export default {
    name: 'technology',
    data() {
        return {
            relUrl: "technology",
            technology: "technology",
            saveAs: false,
            changeInfo: [],
            changeInfo_All: [],
            change_value: "0",
            isRouterAlive: true,
            visibleCreate: '',
            tabList: [],
            tabInfo: {},
            deletePriv: false,
            tabIdLists: [],
            workflowInfo: {
                workflowId: '',
                currentStatusId: ''
            },
            baseClass_: '104',
            creatChange: false,
            createTechnologyChange: 'createTechnologyChange',
        };
    },
    components: {
        Create,
        SaveAsForm,
    },
    mounted() { },
    methods: {
        //操作-创建变更
        addToChangeList(e) {
            this.creatNew = false;
            let insertAffectedItem = e.map((i) => {
                return { changeId: i.id, item: this.$store.state.objectId.id };
            });
            var updateBomData = {
                //post更改的值
                tableId: 5,
                changeObjId: {
                    id: e[0].itemId,
                    classId: e[0].itemClassId,
                    subClassId: e[0].itemSubClassId,
                    version: this.version,
                },
                insertAffectedItem: insertAffectedItem,
            };
            axios.post("/pmdm/changes/saveTable", updateBomData)
                .then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        const obj = {
                            id: e[0].itemId,
                            classId: e[0].itemClass,
                            subClassId: e[0].itemSubClassId,
                            name: e[0].itemNumber
                        }
                        this.getLink(obj);
                        this.$store.commit("setPageRefresh");
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.creatNew = false;
        },
        //操作-收藏
        addFavorite() {
            let description_ = "";
            if (this.tabInfo.description) {
                description_ = ":" + this.tabInfo.description;
            }
            this.addFavoriteInCommon({
                baseClassId: 501,
                number: this.tabInfo.name + description_,
                ...this.$store.state.objectId,
            });
        },
        //操作-取消收藏
        removeFavorite() {
            this.removeFavoriteInCommon({
                baseClassId: 501,
                number: this.tabInfo.name,
                ...this.$store.state.objectId,
            });
        },
        //操作-删除
        deleteTechnology() {
            this.$confirm(
                this.$t("message.confirm.deleteObject"),
                this.$t("message.tips.tip"),
                {
                    confirmButtonText: this.$t("message.button.affirm"),
                    cancelButtonText: this.$t("message.button.cancel"),
                    type: "warning",
                }
            )
                .then(() => {
                    let obj = {
                        ...this.$store.state.objectId,
                    };
                    axios
                        .get(`/pmdm/technology/deleteTechnologyP1${this.params(obj)}`)
                        .then((res) => {
                            if (res.data.code == 200) {
                                this.$message.success(res.data.message);
                                this.$emit("deletePage", this.tabInfo.name);
                            } else {
                                this.$message({
                                    type: "info",
                                    message: this.$t("message.error.delete"),
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: this.$t("message.tips.deleteCancel"),
                    });
                });
        },
        changeInfoClick() {
            var index = this.change_value;
            var commit_change = {};
            for (var i = 0; i < this.changeInfo_All.changes.length; i++) {
                if (this.changeInfo_All.changes[i].id == index) {
                    commit_change = this.changeInfo_All.changes[i];
                }
            }
            var obj_ = {};
            obj_.changeId = commit_change.id;
            obj_.changeClassId = commit_change.classId;
            obj_.changeSubClassId = commit_change.subClassId;
            this.$store.commit("setChangeInfo2", obj_);
            this.loadPageOne();
            this.change_to_child = obj_;
            // this.loadCodeNumber();
            this.$getTabsIsUsedResult(this.tabIdLists).then(
                res => {
                    this.tabList.map(item => {
                        // item.isResult = res.indexOf(item.id) != -1 ? true:false;
                        const isTrue = res.includes(item.id)
                        this.$set(item, 'isResult', isTrue);
                    });
                }
            );
        },
        refreshTab() {
            this.$getTabsIsUsedResult(this.tabIdLists).then(
                res => {
                    this.tabList.map(item => {
                        const isTrue = res.includes(item.id)
                        this.$set(item, 'isResult', isTrue);
                    });
                }
            );
        },
        routerReload() {
            this.isRouterAlive = false;
            this.$nextTick(() => {
                this.isRouterAlive = true;
            });
        },
        pageRefresh() {
            this.logoInfo();
            this.routerReload()
        },
        cancelSaveAs() {
            this.saveAs = false;
        },
        closeCreateChange() {
            this.creatChange = false;
        },
        reload(e) {
            if (e == undefined) {
                this.logoInfo();
                return;
            }
            const obj = {
                id: e.itemId,
                classId: e.itemClassId,
                subClassId: e.itemSubClassId,
                title: e[0]
            };
            this.getLink(obj);
            this.$store.commit('setPageRefresh');
        },
        checkDelPriv(e) {
            let isSupAdmin = this.$store.state.isSuperAdmin;
            if (e) {
                const arr = JSON.parse(sessionStorage.getItem("userContext")).privs;
                const privsArr = arr.map((i) => {
                    return i.type;
                });
                if (privsArr.indexOf(25) != -1 || isSupAdmin) {
                    this.deletePriv = true;
                }
            }
        },
        tabClick(res, index) {
            this.$store.commit("setTabID", index);
            let obj = technologyTabList.find((i) => {
                return i.id == res.id;
            });
            this.$router.push({
                path: obj.path,
                query: {
                    ...this.$store.state.objectId,
                    changeInfoNum: JSON.stringify(this.changeInfo),
                },
            });
            this.$store.commit('setTabIndex', { ...this.$store.state.objectId, index })

        },
        getTab() {
            console.log(technologyTabList);
            this.$http
                .get("/pmdm/admin/getTab/" + this.$store.state.objectId.subClassId)
                .then((res) => {
                    this.tabList = res.data.object.tabs.map(i => {
                        i.path = technologyTabList.find(j => j.id == i.id).path
                        return i;
                    })
                    const tabIndex = getTabIndex({ ...this.$store.state.objectId })?.index || 0
                    this.tabClick(technologyTabList.find(j => j.id == this.tabList[tabIndex].id), tabIndex)

                    this.tabIdLists = Array.from(this.tabList, ({ id }) => id);
                    this.$getTabsIsUsedResult(this.tabIdLists).then(
                        res => {
                            this.tabList.map(item => {
                                // item.isResult = res.indexOf(item.id) != -1 ? true:false;
                                const isTrue = res.includes(item.id)
                                this.$set(item, 'isResult', isTrue);
                            });
                        }
                    );
                });
        },
        async logoInfo() {
            var obj_get = {
                //获取change
                technologyId: this.$store.state.objectId.id,
                technologySubClassId: this.$store.state.objectId.subClassId,
            };
            const getChangeIdUrl = `/pmdm/technology/getRevInfo${this.params(obj_get)}`;
            const { data: res3 } = await this.$http.get(getChangeIdUrl);
            if (res3.code == 200 && res3.object.revInfo != null) {
                this.changeInfo = this.getChangeSelect(res3.object.revInfo);
                this.change_value = res3.object.revInfo.defaultRev.id;
                this.changeInfo_All = res3.object.revInfo;
                this.$store.commit("setChangeInfo", res3.object.revInfo.defaultRev);
                var obj_ = {};
                obj_.changeId = res3.object.revInfo.defaultRev.id;
                obj_.changeClassId = res3.object.revInfo.defaultRev.classId;
                obj_.changeSubClassId = res3.object.revInfo.defaultRev.subClassId;
                this.change_to_child = obj_;
            }
            this.loadPageOne();

        },
        getPageInfo(obj, cells) {
            let keys = Object.keys(obj);
            let newObj = {};
            Object.values(obj).map((i, e) => {
                let val = cells.find((j) => j.columnId == i)?.val || "";
                Object.assign(newObj, { [keys[e]]: val });
            });
            return newObj;
        },
        loadPageOne() {
            var change_info = this.$store.state.change_info;
            var obj_get = {
                ...this.$store.state.objectId,
                ...change_info,
                tableId: 1,
            };
            var loadTableUrl = `/pmdm/technology/loadTable${this.params(obj_get)}`;
            this.$http.get(loadTableUrl).then((res) => {
                const columnList = res.data.object.table.columnInfo.ids;
                const cells = res.data.object.table.rows[0].cells;
                cells.map((i, e) => (i.columnId = columnList[e]));
                let arr = {
                    name: 5010001,
                    type: 5010002,
                    description: 5010003,
                    lifeCycle: 5010006,
                };
                this.tabInfo = this.getPageInfo(arr, cells);
                this.$store.commit("setTabInfo", this.tabInfo);
                //添加最近访问
                const obj = {
                    baseClassId: 501,
                    number: this.tabInfo.name,
                    ...this.$store.state.objectId,
                };
                this.addRecentVistInCommon(obj);
                this.updateFavoriteInCommon(obj);
            });
        },
    },
    computed: {
        num() {
            return this.tabList.findIndex(i => i.path == this.$route.path)
        }
    },
    created() {
        const { id, classId, subClassId } = this.$route.query;
        const obj = { id, classId, subClassId };
        this.$store.commit("setObjectId", obj);

        this.logoInfo().then(res =>
            this.getTab()
        )

    },
};
</script>

<style></style>

<style scoped>
.content-title {
    display: flex;
    gap: 20px;
    padding-left: 20px;
    margin-top: 8px;

    .content-item {
        padding: 8px 15px;
        font-size: 16px;
        cursor: pointer;

        &:hover {
            border-bottom: 3px solid #4b92ff;
            color: #4b92ff;
        }

        &.active {
            border-bottom: 3px solid #4b92ff;
            color: #4b92ff;
        }
    }


}
</style>
